<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="Customer Table"
            text="List of Customer Key Person"
          >
            <v-spacer/>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              clearable
              single-line
              hide-details/>
            <v-dialog
              v-model="dialog"
              max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="general"
                  dark
                  class="mb-2"
                  v-on="on" >New Item</v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md >
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="[rules.required,rules.max50chars]"
                            label="Name *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="[rules.email]"
                            label="Email"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.phone"
                            :rules="[rules.required,rules.number]"
                            label="Phone No *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.position"
                            label="Position" />
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-select
                            :items="companies"
                            v-model="editedItem.company.id"
                            :rules="[rules.required]"
                            item-text="name"
                            item-value="id"
                            label="Company *"
                            placeholder="Select..."/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-checkbox
                            v-model="checkboxActive"
                            :label="`IsActive`"/>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="blue darken-1"
                      flat
                      @click="close">Cancel</v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="blue darken-1"
                      flat
                      @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="UserList"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              dense
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props" >
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)">edit</v-icon>
                  <!--                  <v-icon-->
                  <!--                    medium-->
                  <!--                    @click="deleteItem(props.item)">delete</v-icon>-->
                  <v-dialog
                    v-model="dialogDelete"
                    max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        medium
                        v-on="on">delete</v-icon>
                    </template>
                    <v-card>
                      <v-card-title class="headline">System Message Confirmation</v-card-title>
                      <v-card-text>
                        Are you sure want to remove this data? <br>
                        "{{ props.item.name }}"
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer/>

                        <v-btn
                          color="red darken-1"
                          text
                          flat
                          @click="dialogDelete = false"
                        >
                          Cancel
                        </v-btn>

                        <v-btn
                          color="green darken-1"
                          text
                          flat
                          @click="deleteItem(props.item.id)"
                        >
                          Ok
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                  </v-dialog>
                </td>
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.name"
                    large
                    lazy
                    persistent
                    @save="saveInline"
                    @cancel="cancelInline"
                    @open="openInline"
                    @close="closeInline"
                  >
                    <div>{{ props.item.name }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="props.item.name"
                        :rules="[rules.required,rules.max50chars]"
                        label="Edit"
                        single-line
                        counter
                        autofocus
                      />
                    </template>
                  </v-edit-dialog>
                </td>

                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.email"

                    lazy

                    @save="save"
                    @cancel="cancelInline"
                    @open="openInline"
                    @close="closeInline"
                  >
                    <div>{{ props.item.email }}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="props.item.email"
                        :rules="[rules.required,rules.email]"
                        label="Edit"
                        single-line
                        counter

                      />
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="">{{ props.item.phone }}</td>
                <td class="">{{ props.item.position }}</td>
                <td class="">{{ props.item.lastUpdateBy }}</td>
                <td >{{ toStringDate(props.item.lastUpdateDate) }}</td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'

  export default {
    mixins: [displayFormatterMixins],
  data: () => ({
    snack: false,
    valid: false,
    lazy: false,
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !value || pattern.test(value) || 'Invalid e-mail.'
      },
      number: value => !isNaN(value) || 'Must be numeric'
    },
    pagination: {},
    UserList: [],
    totalRows: 0,
    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [5, 20, 25, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    dialogDelete: false,
    loading: true,
    search: '',
    headers: [
      { text: '-----Actions-----', value: 'actions', sortable: false },
      { text: 'Name', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Telp', value: 'phone' },
      { text: 'Position', value: 'position' },
      { text: 'Update By', value: 'lastUpdateBy' },
      { text: 'Update Date Time', value: 'lastUpdateDate' }
    ],
    companies: [],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: '',
      email: '',
      phone: '',
      position: '',
      isActive: true,
      company: {
        id: null
      }
    },
    defaultItem: {
      id: null,
      name: '',
      email: '',
      phone: '',
      position: '',
      isActive: true,
      company: {
        id: null
      },
      lastUpdateDate: '',
      lastUpdateBy: ''
    }
  }),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  // called when page is created before dom
  created () {

    // this.companies.push({
    //   'id': '12314','name':'PT X'},{'id':'asdaf323', 'name':'PT Pocari'
    // })

    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
  },

  methods: {
    getCustomers () {
      this.$http.get('/api/customer?ps=15&so=userName')
        .then(response => {
          this.UserList = response.data.content
          this.totalRows = response.data.totalElements
        })
        .catch(error => console.log(error))
    },
    async getCompanies () {
      try {
        let response = await this.$http.get('/api/company')
        this.companies = response.data
      } catch (error) {
        console.log(error)
      }
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedIndex = this.UserList.indexOf(item)
      item.isAdmin = this.checkboxAdmin
      item.isActive = this.checkboxActive
      this.editedItem = Object.assign({}, item)
      this.dialog = dbox
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedItem
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline()
        })
    },

    deleteItem (id) {
      let endpoint = `api/customer/${id}`
      let method = 'delete'
      let s = {}
      this.$store.dispatch('updateTableItem', { endpoint, s, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline()
        })
      this.dialogDelete = false
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (!this.$refs.form.validate()) {
        console.log('validation fail direct')
      }
      if (this.$refs.form.validate()) {
        console.log('validation success')
      }
      if (this.editedIndex > -1) {
        Object.assign(this.UserList[this.editedIndex], this.editedItem)
        let tableItem = this.editedItem
        let endpoint = `api/customer/${this.editedItem.id}`
        let method = 'patch'
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      } else {
        let tableItem = this.editedItem
        this.UserList.push(this.editedItem)
        let endpoint = `api/customer`
        let method = 'post'
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => console.log('new user'))
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      }
      this.close()
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data removed'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    }
  }
}
</script>

<style scoped>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
</style>
